import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SelfCreate } from "../components/selfserve/SelfCreate";
import { SelfFooter } from "../components/selfserve/SelfFooter";
import { SelfHeader } from "../components/selfserve/SelfHeader";
import { SelfTellUs } from "../components/selfserve/SelfTellUs";
import { SelfWelcome } from "../components/selfserve/SelfWelcome";
import "./SelfServe.scss";

const BREAK_POINT = 800
export const SelfServe = (props: {tellUs?: boolean}) => {
    const [mobile, setMobile] = useState(window.innerWidth <= BREAK_POINT)
    const {create} = useParams()

    const handleWindowSizeChange = () => {
        setMobile(window.innerWidth <= BREAK_POINT);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, [])

    return <div className="self-serve">
        <SelfHeader mobile={mobile}/>
        {props.tellUs ?
            <SelfTellUs mobile={mobile}/> :
            create ? <SelfCreate mobile={mobile} length={create}/> :
                <SelfWelcome mobile={mobile}/>}
        <SelfFooter mobile={mobile}/>
    </div>
}